import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDo4eMQG1sS86Y_cjjp-tqrDTbqP0bVs88",
  authDomain: "anugraha-website.firebaseapp.com",
  projectId: "anugraha-website",
  storageBucket: "anugraha-website.firebasestorage.app",
  messagingSenderId: "648780097261",
  appId: "1:648780097261:web:99c386d9b93b04ccff8ee4",
  measurementId: "G-ZHD0B8J8BX"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const analytics = typeof window !== "undefined" ? getAnalytics(app) : null;
